<template>
  <section class="home-regions">
    <h2 class="home-regions__title">{{ sectionTitle }}</h2>
    <p class="home-regions__subtitle">{{ sectionSubtitle }}</p>

    <div class="home-regions__grid">
      <template v-for="(region, index) in regions">
        <a :key="region.name" class="home-regions__card" :href="getRegionUrl(region.key)">
          <div class="home-regions__card-image"
            :style="{ backgroundImage: `url(${region.image})` }">
            <div class="home-regions__card-overlay">
              <span class="home-regions__card-icon"><svg width="12" height="14" viewBox="0 0 14 16"
                  fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7 0C10.8636 0 14 2.90175 14 6.47627C14 8.33762 12.9961 10.2535 11.7357 11.8622C9.97583 14.1091 7.77494 15.7472 7.77494 15.7472C7.32241 16.084 6.67759 16.0844 6.22506 15.7476C6.22506 15.7476 4.02417 14.1091 2.26429 11.8622C1.00388 10.2535 0 8.33762 0 6.47627C0 2.90175 3.13641 0 7 0ZM7 3.80957C8.59065 3.80957 9.88235 5.00463 9.88235 6.47627C9.88235 7.9479 8.59065 9.14297 7 9.14297C5.40935 9.14297 4.11765 7.9479 4.11765 6.47627C4.11765 5.00463 5.40935 3.80957 7 3.80957Z"
                    fill="black" />
                </svg></span>
              <span class="home-regions__card-name">{{ region.name }}</span>
            </div>
          </div>
        </a>
        <div v-if="isMobile && index === 1 && adHome2" :key="`home2-mobile-${index}`"
          class="home-regions__grid-ad">
          <AdComponent class="ad-width-100" :ads="adHome2" :showDebug="showAdDebug"
            :forceDebug="true" debugLabel="home_2" debugPosition="By Region 第一行卡片下方（仅移动端）" />
        </div>
      </template>
    </div>

    <div class="home-regions__map"></div>
    <div v-if="!isMobile && adHome2" class="home-regions__pc-ad">
      <AdComponent class="ad-width-100" :ads="adHome2" :showDebug="showAdDebug" :forceDebug="true"
        debugLabel="home_2" debugPosition="地球图案下方（仅PC）" />
    </div>
    <div v-if="isMobile && adMobileMap" class="home-regions__map-ad">
      <AdComponent class="ad-width-100" :ads="adMobileMap" :showDebug="showAdDebug"
        :forceDebug="true" debugLabel="home_3" debugPosition="地球图案下方（仅移动端）" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import AdComponent from '@/pages/components/AdComponent.vue'
import adMixin from '@/mixin/adMixin.js'

export default {
  name: 'HomeRegionCards',
  components: {
    AdComponent
  },
  mixins: [adMixin],
  props: {
    adHome2: {
      type: Object,
      default: () => ({})
    },
    adMobileMap: {
      type: Object,
      default: () => ({})
    },
    showAdDebug: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['livableCityData', 'deviceType']),
    sectionTitle () {
      return "Find livable cities across the world's corners."
    },
    sectionSubtitle () {
      return 'By Region'
    },
    regions () {
      return this.livableCityData.homeRegionCards || []
    },
    isMobile () {
      return this.deviceType === 'mobile'
    }
  },
  methods: {
    getRegionUrl (region) {
      return this.getPageUrl(`/cities?region=${region}`)
    },
    getPageUrl (path) {
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${path}`;
      }
      return path;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-regions {
	width: 100%;
	box-sizing: border-box;

	&__title {
		margin: 0;
		text-align: center;
		color: #000;
		font-family: $font-family-serif;
		font-size: rem(28);
		font-weight: 700;
		line-height: rem(36);
	}

	&__subtitle {
		margin: rem(12) 0 rem(40);
		text-align: center;
		color: #000;
		font-family: $font-family-serif;
		font-size: rem(16);
		font-weight: 300;
		line-height: rem(16);
	}

	&__grid {
		display: grid;
	}

	&__grid-ad {
		grid-column: 1 / -1;
	}

	&__card {
		border-radius: rem(24);
		overflow: hidden;
		border: 1px solid $color-border;
		text-decoration: none;
		transition: transform 0.25s ease;
		cursor: pointer;

		&:hover {
			transform: translateY(rem(-6));
		}
	}

	&__card-image {
		position: relative;
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
	}

	&__card-overlay {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		gap: rem(8);
		padding: rem(12);
		background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, #000 80%);
	}

	&__card-icon {
		width: rem(28);
		height: rem(28);
		border-radius: 50%;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: $color-primary;
		box-shadow: 0 rem(2) rem(4) rgba(0, 0, 0, 0.16);
		font-size: rem(14);
	}

	&__card-name {
		color: #fff;
		font-family: $font-family-serif;
		font-weight: 700;
		text-shadow: 0 rem(2) rem(4) rgba(0, 0, 0, 0.16);
	}

	&__map {
		position: relative;
		overflow: hidden;
		border-radius: rem(24);
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		background-image: url('~@/assets/world-pc.png');
	}

	&__pc-ad {
		margin-top: rem(24);
	}

	&__map-ad {
		margin-top: rem(16);
	}
}

.detect_deviece_pc,
.detect_deviece_desktop {
	.home-regions {
		padding: rem(60) rem(180) rem(40);

		&__grid {
			grid-template-columns: repeat(4, minmax(0, 1fr));
			gap: rem(24);
		}

		&__card {
			height: rem(378);
		}

		&__card-overlay {
			gap: rem(12);
			padding: rem(24);
		}

		&__card-name {
			font-size: rem(24);
			line-height: rem(24);
		}

		&__map {
			width: 100%;
			max-width: rem(1080);
			height: rem(360);
			margin: rem(24) auto 0;
		}
	}
}

.detect_deviece_mobile {
	.home-regions {
		padding: rem(60) rem(16) rem(40);

		&__grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: rem(12);
		}

		&__card {
			height: rem(246);
		}

		&__card-name {
			font-size: rem(20);
			line-height: rem(24);
		}

		&__map {
			margin: rem(24) 0 0;
			width: 100%;
			height: rem(260);
			background-image: url('~@/assets/world-m.png');
			background-size: contain;
		}
	}
}
</style>
